import { useMemo } from 'react';
import type { IColumn } from '../../../../api';
import { FilterOptionType } from '../../../../components/Filter';
import { useGenericColumns } from '../../../../components/TableV2/SecodaEntity.hooks';
import {
	CapitalizeTextRender,
	ColumnProfileRender,
} from '../../../../components/TableV2/render';
import type {
	ExtendedDataTableColumn,
	Render,
} from '../../../../components/TableV2/types';

import type { ICommandListItem } from '../../../../components/Spotlight/components/CommandPalette/constants';
import { useActions as useCatalogActions } from '../../../TeamCatalogPage/TeamCatalogPage.hooks';

export const useActions = () => {
	const actions = useCatalogActions() as unknown as ICommandListItem<IColumn>[];

	return actions;
};

export function useColumns(): ExtendedDataTableColumn<IColumn>[] {
	const genericColumns = useGenericColumns({});

	const columns = useMemo(
		() => [
			{
				accessor: 'type',
				titleLabel: 'Type',
				width: 160,
				render: (record: IColumn) => (
					<CapitalizeTextRender<IColumn>
						record={record}
						field={'type'}
						field2={'native_type'}
					/>
				),
				filterOptionType: FilterOptionType.NATIVE_TYPE,
			},
			...genericColumns,
			{
				accessor: 'profile_data.ntiles',
				titleLabel: 'Distribution',
				sortable: false,
				filtering: false,
				explicit: true,
				width: 160,
				render: ColumnProfileRender as unknown as Render<IColumn>,
			},
		],
		[genericColumns]
	);

	return columns;
}
